export const DEVCON_2024_EDDSA_PUBKEY = [
    "044e711fd3a1792a825aa896104da5276bbe710fd9b59dddea1aaf8d84535aaf",
    "2b259329f0adf98c9b6cf2a11db7225fdcaa4f8796c61864e86154477da10663"
];
